import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"

import responsive from "@styles/responsive"

const Container = styled.div`
  .category-text {
    color: #fff;
    border-radius: 2px;
    font-size: 1.6rem;
    font-weight: 700;
    display: inline-block;
    padding: 4px 8px;
    line-height: 1.2;

    ${responsive.lg} {
      font-size: 14px;
      padding: 2.5px 6px;
    }
  }
`

const CategoryLabel = ({ category, isLink }) => {
  if (!category) return null
  const { name, color, slug } = category
  const labelColor = color || "#6d4bf5"

  const content = isLink ? (
    <Link
      to={`/${slug}`}
      className="category-text"
      style={{
        background: labelColor,
      }}
    >
      {name}
    </Link>
  ) : (
    <span
      className="category-text"
      style={{
        background: labelColor,
      }}
    >
      {name}
    </span>
  )

  return <Container>{content}</Container>
}

export default CategoryLabel
